import { render, staticRenderFns } from "./approval-form.vue?vue&type=template&id=6695e499"
import script from "./approval-form.vue?vue&type=script&lang=js"
export * from "./approval-form.vue?vue&type=script&lang=js"
import style0 from "./approval-form.vue?vue&type=style&index=0&id=6695e499&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports